// extracted by mini-css-extract-plugin
module.exports = {"root":"AdvantageBanner-module--root--2VObh","container":"AdvantageBanner-module--container--3jFkz"};